// extracted by mini-css-extract-plugin
export default {"row":"BoardListViewItem_row__zVqaq","col":"BoardListViewItem_col__T3yqW","button":"BoardListViewItem_button__smTGX"};